// extracted by mini-css-extract-plugin
module.exports = {"list":"_11889"};